import React from 'react'

const Checkbox = ({ name,onChange }) => {
    const handleCheckboxChange = event => {
        const isChecked = event.target.checked;
        onChange(isChecked);
    };
    return (
        <div >
            <input type="checkbox" className="btn-check "  name={name} id={name}  onChange={handleCheckboxChange}/>
            <label className="btn radio-shadow" htmlFor={name}>{name}</label>
        </div>
    )
}

export default Checkbox
